<template>
	<div>
		<div v-if="eventNotfound" class="alert alert-info">
			{{ t.error.notfound_fixture }}
		</div>

		<table class="table table-padded" v-if="loader">
			<tbody>
			<tr class="competition_head">
				<td colspan="10"><strong>{{ t.loading.fixture }}</strong></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			</tbody>
		</table>

		<div class="white-box match-e" v-for="sport in events" v-if="events">

			<div class="white-box match-e" v-for="region in sport.region" v-if="events">
			<table class="table table-padded" v-for="comp in region.competition">
				<tbody>
				<tr>
					<td class="competition_head" colspan="8">
						<strong> {{sport.name}} » {{region.name}} » {{ comp.name }} </strong>
						<div id="toggles" class="pull-left pr-2" v-tooltip="'Disable it'">
							<input type="checkbox" class="ios-toggle" v-on:change="actionCompetitionStatus(comp.competitionId)" :id="'cou_'+comp.competitionId" v-model="comp.isActive" :name="'cou_'+comp.competitionId" value="1">
							<label :for="'cou_'+comp.competitionId" class="checkbox-label"></label>
						</div>
					</td>
					<td class="competition_head">
						<select style="width: 150px" name="x" class="form-control pull-right" @change="saveClass(comp)" v-if="comp.class" v-model="comp.class">
						<option v-for="c in classes" :value="c.id">{{ c.name }}</option>
						</select>
					</td>
				</tr>
				<tr v-for="match in comp.matches">
					<td width="100">
						<div id="toggles" class="pt-2 pull-right" v-tooltip="t.disable_this_match_on_the_fixture">
							<input type="checkbox" class="ios-toggle" v-on:change="changeStatus(match.matchId, match.isDisabled)" :id="'ou_'+match.matchId" v-model="match.isDisabled" :name="'ou_'+match.matchId" value="1" v-if="">
							<label :for="'ou_'+match.matchId" class="checkbox-label"></label>
						</div>
					</td>
					<td width="110" style="word-wrap: break-word;">
						{{ match.resultName }} {{ periodTimer(match) }}
					</td>
					<td width="120" class="text-center px-1">
							{{ match.startDate | moment('dddd', session.timezone) | slimiter(10) }}
						<span class="smaller lighter">
							{{ match.startDate | moment('DD MMM', session.timezone) | slimiter(10) }}
							{{ match.startDate | moment('HH:mm', session.timezone) }}
						</span>
					</td>
					<td width="200" class="text-right">
						<router-link :to="{params: {id: match.matchId}, query: $route.query }">
							{{ match.competitor.oneName | slimiter(25) }}
						</router-link>
					</td>
					<td width="30" class="p-0 text-center competition_head">
						<img width="25" height="25" :src="'https://img.sportradar.com/ls/crest/medium/'+match.competitor.oneEid+'.png'"/>
					</td>
					<td width="50" class="p-0 text-center">
						<template v-if="match.data.score">
							{{ match.data.score.home }}:{{ match.data.score.away }}
						</template>
					</td>
					<td width="30" class="p-0 text-center competition_head">
						<img width="25" height="25" :src="'https://img.sportradar.com/ls/crest/medium/'+match.competitor.twoEid+'.png'"/>
					</td>
					<td width="200" class="text-left">
						<a href="javascript:;" v-on:click="showMatchDetails(match.matchId)">
							{{ match.competitor.twoName | slimiter(25) }}
						</a>
					</td>
					<td width="30">
						<select style="width: 150px" name="x" class="form-control pull-right" @change="saveMatchClass(match)" v-model="match.class">
						<option v-for="c in classes" :value="c.id">{{ c.name }}</option>
						</select>
					</td>
				</tr>
				</tbody>
			</table>
			</div>
		</div>

		<paginate v-if="pagination"
				:page-count="pagination.pageCount"
				:page-range="pagination.pageRange"
				:force-page="(pagination.current-1)"
				:margin-pages="2"
				:click-handler="onChangePage"
				:prev-text="t.previous"
				:next-text="t.next"
				:container-class="'pagination float-right'"
				:page-class="'page-item'"
				:page-link-class="'page-link'"
				:prev-class="'page-item'"
				:prev-link-class="'page-link'"
				:next-class="'page-item'"
				:next-link-class="'page-link'"
		>
		</paginate>

		<sweet-modal v-on:close="closeMatch" :title="(match) ? match.first_competitor.name +' vs '+match.second_competitor.name : ''" ref="matchmodal" width="100%" height="100%">

			<sweet-modal-tab title="Overview" id="tab1">
				<template v-if="match">
					<scoreboard collapseTo="scoreboard" layout="mini" :matchId.sync="match.radar_idnnpm " />
					<matchDetail :matchId.sync="match.radar_id" />
				</template>
			</sweet-modal-tab>

			<sweet-modal-tab :title="t.periods" id="tab1">
				<template v-if="event">
					<Periods :event="event" />
				</template>
			</sweet-modal-tab>

			<sweet-modal-tab :title="t.events" id="tab2">
				<template v-if="match">
					<Events :event="event" :match="match" />
				</template>
			</sweet-modal-tab>

			<sweet-modal-tab :title="t.informations" id="tab3">
				<template v-if="event">
					<matchForm :event="event" />
				</template>
			</sweet-modal-tab>

			<sweet-modal-tab :title="t.navigation.bets" id="tab3">
				<template v-if="event">
					<odd :matchId="event" live="false" />
				</template>
			</sweet-modal-tab>

			<sweet-modal-tab title="Logs" id="tab3">
				<template v-if="event">
					<activityWidget :filter="{dataId: event, type: [9,15,16,17,18]}" />
				</template>
			</sweet-modal-tab>

		</sweet-modal>
	</div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import ContentPlaceholder from 'vue-content-placeholder'
    import Periods from '@/components/stats/match/periods'
    import Events from '@/components/stats/match/events'

    import mainOdds from '@/components/stats/odds/mainOdds'
    import underOverOdds from '@/components/stats/odds/underOverOdds'
    import handicap from '@/components/stats/odds/handicap'
    import winOdds from '@/components/stats/odds/winOdds'
    import matchForm from '@/components/stats/match/matchForm.vue'
    import odd from '@/components/stats/odds/odd';
    import scoreboard from '@/components/stats/widget/scoreboard'
    import matchDetail from '@/components/stats/widget/matchDetail'
    import feed from '@/mixins/feed.js'
	import activityWidget from '@/components/user/widget/activityWidget'

    export default {
        name: 'matches',
	      components: { activityWidget, ContentPlaceholder, Paginate, Periods, mainOdds, underOverOdds, handicap, winOdds, Events, matchForm,odd,scoreboard,matchDetail },
        props: {
            filter: {}
        },
        data () {
            return {
                match: null,
                event: null,
                app: this.$root.app,
                session: window.session,
                loader: true,
                t: this.$root.t,
                events: [],
                eventNotfound: false,
	              loader: false,
                selectedEventDate: false,
                session: session,
                pagination: [],
                page: 1,
                classes: [],
                placeholderRows:  [
                    { height: '1rem',
                        boxes: [[0, '20%'], ['2%', '15%'], ['2%', '30%'], ['20%', '8%']]
                    },
                ]
            }
        },
        mixins: [feed],
        watch: {
            'filter' () {
                this.fetchEvents();
            },
	        '$route.params.id' (e) {
                this.showMatchDetails (this.$route.params.id);
	        }
        },
	    mounted () {

        this.fetchClass().then(response => {
          response.body.forEach((e) => {
            this.classes.push({name: e.name, id: e.id})
          });
        });

            this.fetchEvents();

            if(this.$route.params.id)
                this.showMatchDetails (this.$route.params.id);

        },
	    methods: {
            closeMatch (){
                this.match = null;
                this.event = null;
                this.$router.push({ params: {id: null}, query: this.$route.query });
                //this.$router.push({ query: this.filter });
            },
            setEvent(id){
                this.event = id;
            },
            saveMatchClass(c){
              this.$http.get(api+'api/v1/match/class/'+c.matchId+'/'+c.class).then(response => {
                // get body data

              }, response => {
                // error callback

              })
            },
            saveClass(c){
              this.$http.get(api+'api/v1/competition/class/'+c.competitionId+'/'+c.class).then(response => {
                // get body data

              }, response => {
                // error callback

              })
            },
            changeStatus (m, d) {
                this.$http.get(api+'api/v1/fixture/api_v1_set_match_is_disable', {
                    params: {data: d, match: m }
                }).then(response => {
                    // get body data

                }, response => {
                    // error callback

                })
            },
            onChangePage (page) {
                this.pagination.current = page;
                this.filter.page = page;
                this.$router.push({ params: {}, query: {} });
                this.$router.push({ query: this.filter });
            },
            fetchMatch () {
                this.$http.get(bsapi+'api/v1/fixture/match/'+this.event).then(response => {

                    this.match = response.body.match;
                }, response => {

                })
            },
            fetchEvents () {
                this.loader = true;
                //this.events = [];
                this.eventNotfound = false;
                this.$http.get(bsapi+'api/v1/fixture/matches?fullList=true&_='+(Math.floor(Date.now() / 1000))+'&app='+this.app.id, {
					params: this.filter
                }).then(response => {
                    // get body data
                    this.events = response.body.result.sport;
                    this.pagination = response.body.pagination;
                    this.loader = false;
                    this.eventNotfound = false;

                }, response => {
                    // error callback
                    this.eventNotfound = true;
                    this.loader = false;
                })
            },
            showMatchDetails (e) {
                this.event = e;
                this.fetchMatch()
                this.$refs.matchmodal.open()
            },
			        periodTimer (m) {

            if(m.periodTimeLeft != 0){

                return m.periodTimeLeft;

            }else if(m.periodTime > 0){

                var min = (parseInt((m.periodTime / 60).toFixed(0)) + 1);

                if(m.resultName == "1st half" && m.periodTime >= 2700)
                    return "45' +"+Math.abs(45 - min);

                if(m.resultName == "2nd half" && m.periodTime >= 5400)
                    return "90' +"+Math.abs(90 - min);

                return (min > 0) ? min+"'" : '';
            }

            if(m.periodCounter > 0){
                const min = (m.roundCounter / 3600).toFixed(2);

                return (min > 0) ? min+"'" : '';
            }
        },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.competition_head{
		border-bottom: 3px solid #73518e !important;
	}
	h1, h2 {
		font-weight: normal;
	}
	ul {
		list-style-type: none;
		padding: 0;
	}
	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/matches.vue